import { gql } from "@apollo/client";

// Each report returns one JSON object; keys are documented in the backend
// files under src/modules/team-insights.
const report = (name, field) => gql`
  query ${name}($filter: TeamInsightsFilter) {
    ${field}(filter: $filter) {
      status
      message
      data
    }
  }
`;

export const GET_TEAM_SCORECARD = report("GetTeamScorecard", "getTeamScorecard");
export const GET_SERVICE_TIME = report("GetServiceTimeReport", "getServiceTimeReport");
export const GET_PRODUCTIVITY = report("GetProductivityReport", "getProductivityReport");
export const GET_RISK = report("GetRiskReport", "getRiskReport");
export const GET_OFFICE_SPEED = report("GetOfficeSpeedReport", "getOfficeSpeedReport");
